import { createReducer } from 'reduxsauce'
import { Types } from '../actions/pendenciasActions'

const INITIAL_STATE = { error: false, loading: false, relatorio: null }

const begin = (state = INITIAL_STATE, action) => {
    return { ...state, error: false, loading: true, relatorio: null }
}
const success = (state = INITIAL_STATE, action) => {
    return { ...state, error: false, loading: false, relatorio: action.relatorio }
}
const failure = (state = INITIAL_STATE, action) => {
    return { ...state, error: action.error, loading: false, relatorio: null }
}
const clean = (state = INITIAL_STATE, action) => {
    return { ...state, error: false, loading: false, relatorio: null }
}

const HANDLERS = {
    [Types.PENDENCIAS_DOCSYSTEM_BEGIN]: begin,
    [Types.PENDENCIAS_DOCSYSTEM_SUCCESS]: success,
    [Types.PENDENCIAS_DOCSYSTEM_FAILURE]: failure,
    [Types.PENDENCIAS_DOCSYSTEM_CLEAN]: clean,
}

export default createReducer(INITIAL_STATE, HANDLERS)